(function () {
  'use strict';

  class CamadaValorCadastroCtrl {
    constructor(Authenticator) {
      this.auth = Authenticator;
      this.init();
    }

    init() {
      this.auth.getUser().then(user => {
        /* eslint-disable */
        const elementContainer = document.querySelector('#camada-valor-stepper-cadastro'),
        stepperCadastro = document.createElement('pwc-camada-valor-stepper-cadastro');
        /* eslint-enable */

        if (stepperCadastro) {
          stepperCadastro.uoId = user.plain().uo.id;
          elementContainer.appendChild(stepperCadastro);
        }
      });
    }
  }
  /**
   * @ngdoc object
   * @name camadaValor.controller:CamadaValorCadastroCtrl
   *
   * @description
   *
   */

  angular
    .module('camadaValor')
    .controller('CamadaValorCadastroCtrl', CamadaValorCadastroCtrl);
}());
